import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'utils/components/tooltip';
import InfoTooltip from 'utils/components/info-tooltip';
import validators from 'app/scripts/utils/validators';
import classnames from 'classnames';
import debounce from 'utils/debounce';
import { saveBrandColor } from '../../../preferences/api';

const displayName = 'BrandColor';

var colorsList = [
  '#a0050d',
  '#ef3541',
  '#f35273',
  '#f1622e',
  '#ffae00',
  '#84b230',
  '#2ab37c',
  '#37835c',
  '#21aae4',
  '#307fe2',
  '#0968ba',
  '#014a8c',
  '#7d71ce',
  '#775173',
  '#916968',
  '#6f5454'
];

class BrandColor extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      error: null,
      success: null,
      brandColor: props.value || '',
      inputFocus: false
    };
  }

  componentDidUpdate() {
    if (this.state.inputFocus) {
      this.refs.inputField.focus();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.value) {
      this.setState({ brandColor: nextProps.value });
      this.brandColorUpdate(nextProps.value, true);
    }
  }

  UNSAFE_componentWillMount() {
    this.saveBrandColor = debounce(this.saveBrandColor.bind(this), 500);
  }

  saveBrandColor() {
    if (this.props.autoSave) {
      this.props.editSpot({ brand_color: this.state.brandColor });
      saveBrandColor(this.props.spotId, this.props.spotName, this.state.brandColor);
    }
  }

  getValue() {
    return this.state.brandColor;
  }

  isValid() {
    return !!this.state.success;
  }

  toggleColorPicker() {
    this.refs.colorPickerTooltip.toggle();
  }

  renderMessage() {
    var error = this.state.error;
    var success = this.state.success;

    return (
      <div className={'validation ' + (error ? 'validation-error' : 'validation-success')}>
        <i className={'icon ' + (error ? 'error-icon' : 'success-icon')} />
        <span className="text">{error ? error : success}</span>
      </div>
    );
  }

  renderTooltipMessage() {
    var error = this.state.error;
    var success = this.state.success;

    return (
      <i className="icon" ref="infoTooltipAlign">
        <InfoTooltip
          ref="infoTooltip"
          alignElement={() => this.refs.infoTooltipAlign}
          direction="top"
        >
          <span className="text">{error || success}</span>
        </InfoTooltip>
      </i>
    );
  }

  showInfoTooltip() {
    if (this.props.showValidationTooltip && this.refs.infoTooltip) {
      this.setState({ inputFocus: true });
      this.refs.infoTooltip.show();
    }
  }

  hideInfoTooltip() {
    if (this.props.showValidationTooltip && this.refs.infoTooltip) {
      this.setState({ inputFocus: false });
      this.refs.infoTooltip.hide();
    }
  }

  stopTooltipInfoClick(event) {
    event.stopPropagation();
  }

  handleBrandColorChange(event) {
    var brandColor = typeof event === 'string' ? event : event.currentTarget.value;

    this.brandColorUpdate(brandColor);
  }

  brandColorUpdate(color, onlyUpdate) {
    var empty = !color || !color.trim().length;
    var valid = validators.hex(color);
    var state = this.state;

    onlyUpdate = !!onlyUpdate;
    state.success = null;
    if (empty) {
      state.error = "You can't leave this empty.";
    } else if (!valid) {
      state.error = 'Please enter a valid HEX Color format.';
    } else {
      state.error = null;
      state.success = '';

      if (!onlyUpdate) {
        this.saveBrandColor();
      }
    }

    state.brandColor = color;
    this.setState(state);
  }

  colorPicker() {
    var colors = colorsList.map(color => {
      var selectedIcon = null;
      if (color === this.state.brandColor) {
        selectedIcon = <i className="selected-icon" />;
      }

      return (
        <div
          key={color}
          onClick={this.handleBrandColorChange.bind(this, color)}
          className="color-option"
          style={{ backgroundColor: color }}
        >
          {selectedIcon}
        </div>
      );
    });

    return <div className="color-picker">{colors}</div>;
  }

  render() {
    var selectedColor = this.state.brandColor;
    var success = this.state.success;
    var error = this.state.error;
    var validate = this.props.validate;
    var showValidationTooltip = this.props.showValidationTooltip;

    var hexInputClassNames = classnames('text-field-regular', 'outside', this.props.className, {
      error: !!error,
      success: !!success
    });

    var message = null;
    var tooltipMessage = null;
    if ((success || error) && validate) {
      if (showValidationTooltip) {
        tooltipMessage = this.renderTooltipMessage();
      } else {
        message = this.renderMessage();
      }
    }
    var commentComponent = null;
    if (!this.props.hasComment) {
      commentComponent = (
        <span className="comment">
          We recommend you choose a brand color. White cannot be chosen.
        </span>
      );
    }
    var className = 'field branded-color';
    if (this.props.mainClassName) {
      className += ` ${this.props.mainClassName}`;
    }
    return (
      <div className={className}>
        <div className="field-title">Site Color</div>
        <div className="field-description">
          This color will be used across the UI to fit visually with your site.
        </div>
        {message}
        <div className="color-input">
          <div
            className="color-dropdown"
            ref="colorPickerAlign"
            style={{ backgroundColor: selectedColor }}
            onClick={this.toggleColorPicker.bind(this)}
          >
            <Tooltip
              className="tooltip-general"
              ref="colorPickerTooltip"
              direction="top"
              alignElement={() => this.refs.colorPickerAlign}
            >
              {this.colorPicker()}
            </Tooltip>
          </div>
          <div className={hexInputClassNames}>
            {tooltipMessage}
            <input
              ref="inputField"
              type="text"
              value={selectedColor}
              onChange={this.handleBrandColorChange.bind(this)}
              onClick={this.stopTooltipInfoClick}
              onFocus={this.showInfoTooltip.bind(this)}
              onBlur={this.hideInfoTooltip.bind(this)}
              maxLength={7}
            />
          </div>
        </div>
        {commentComponent}
      </div>
    );
  }
}

BrandColor.propTypes = {
  autoSave: PropTypes.bool,
  showValidationTooltip: PropTypes.bool,
  spotId: PropTypes.string,
  spotName: PropTypes.string,
  validate: PropTypes.bool,
  value: PropTypes.string,
  className: PropTypes.string,
  hasComment: PropTypes.bool
};

BrandColor.defaultProps = {
  autoSave: false,
  showValidationTooltip: false,
  spotId: null,
  validate: true,
  value: '#307fe2',
  hasComment: false
};

BrandColor.displayName = displayName;
BrandColor.contextTypes = {
  executeAction: PropTypes.func.isRequired
};

export default BrandColor;
